import React from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import abcdropone from './img/ABCDrop/abcdropone.png';
import abcdropthree from './img/ABCDrop/abcdropthree.png';
import abcdropfour from './img/ABCDrop/abcdropfour.png';
import abcdropoptions from './img/ABCDrop/abcdropoptions.png';


export const ABCDrop = ({}) => {



	return (
		<div className="container-fluid appdesc">
<div className="row padrow">
 <div className="col-md-8 col-lg-8">
			 <h2>ABC Drop Bubble Pop</h2>
 </div>
 <div className="col-md-4 col-lg-4">
      <a href='https://play.google.com/store/apps/details?id=com.helenssc.AlphabetBubbles&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' className="appimage img-responsive d-block mx-auto auditpic googlebadge"/></a>
 </div>

 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12 centervideo">
  <iframe width="560" height="315" src="https://www.youtube.com/embed/XPuIjFlGoSU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
 </div>
 </div>
  <div className="row padrow">
  <div className="col-md-12 col-lg-12 youtube">

  <a href='https://www.youtube.com/channel/UC4eN-brmGnxMLAYw3N5tA_g?view_as=subscriber?sub_confirmation=1'><b>Subscribe to YouTube Channel!</b>

  </a>
 </div>
 </div>
<div className="row padrow">
<div className="col-md-12 col-lg-12">
			Bubbles float blissfully down the screen.
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src={ abcdropone } alt="Opening screen of ABC Drop Bubble Pop Application" className="appimage img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>
 <div className="row padrow">
<div className="col-md-12 col-lg-12">
			Gently pop with a finger to reveal a lovely, bubbly, letter or number.
			 </div>
 </div>
 <div className="row padrow">
       <div className="col-md-6 col-lg-6 text-center">


  <img src={ abcdropfour }alt="ABC Drop Bubble Pop screen shot" className="appimage img-responsive img-thumbnail d-block mx-auto timerpic"/>
        </div>
  <div className="col-md-6 col-lg-6 text-center">

   <img src={ abcdropthree } alt="ABC Drop Bubble Pop screen shot" className="appimage img-responsive img-thumbnail d-block mx-auto timerpic"/>
        </div>
       </div>
	<div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 Options include four backgrounds, letters or numbers, random or in order, item frequency, and bubble speed.
 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
      <img src={ abcdropoptions } alt="Options screen of ABC Drop Bubble Pop Application" className="appimage img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>

			 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
 Please let us know if you experience any issues are have any suggstions at our feedback form <Link to="/feedback" >
 here
 </Link>.  </div>
 </div>


</div>

			)


}
